export enum ENV_TYPE {
  LOCAL = 'local',
  DEV = 'dev',
  STAGING = 'staging',
  UAT = 'uat',
  SIT = 'sit',
  PROD = 'prod',
}
